<template>
  <el-col :span="span">
    <el-form-item :label="label" :required="required">
      <!--普通输框-->
      <el-input :disabled="disabled" :placeholder="placeholder || '请填写' + label" v-if="!types && !input"
        v-model="myValue" :autosize="autosize" :rows="rows" :type="type" :readonly="readonly"
        @change="handleChange" @clear="()=>myValue=null"></el-input>
      <!--类型输入框-->
      <el-select :disabled="disabled" :placeholder="placeholder || '请选择' + label" v-if="types && input !== 'node'"
        v-model="myValue" value-key="id" :readonly="readonly" filterable :multiple="multiple" clearable
        @change="handleChange" @clear="()=>myValue=null">
        <!-- <el-option value=""></el-option> -->
        <el-option v-for="opt in types" :label="opt.name" :key="opt.id" :value="opt.id"
          :disabled="opt.disabled"></el-option>
      </el-select>
      <!--上传输入框-->
      <my-upload :disabled="disabled" v-if="input === 'upload'" :placeholder="placeholder || '请上传' + label"
        :accept="accept" v-model="myValue" :readonly="readonly"></my-upload>
      <!--上传多个文件框-->
      <my-uploads :disabled="disabled" v-if="input === 'uploads'" :myid="myid"
        :placeholder="placeholder || '请上传' + label" :accept="accept" v-model="myValue"
        :readonly="readonly"></my-uploads>
      <!--富文本输入框-->
      <my-edit-input :disabled="disabled" v-if="input === 'edit'" :placeholder="placeholder || '请填写' + label"
        v-model="myValue" :readonly="readonly"></my-edit-input>
      <!--日期时间输入框-->
      <el-date-picker :disabled="disabled" v-if="input === 'datetime'" :placeholder="placeholder || '请选择' + label"
        v-model="myValue" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" style="width: 100%"
        @change="handleChange"></el-date-picker>
      <!--日期输入框-->
      <el-date-picker :disabled="disabled" v-if="input === 'date'" :placeholder="placeholder || '请选择' + label"
        v-model="myValue" value-format="yyyy-MM-dd" type="date" style="width: 100%"
        @change="handleChange"></el-date-picker>
      <!--级联输入框-->
      <el-cascader :disabled="disabled" v-if="input === 'node'" :placeholder="placeholder || '请选择' + label"
        v-model="myValue" :options="types" :props="$cascader" :show-all-levels="false" clearable style="width:100%"
        @change="handleChange"></el-cascader>
      <!--地图坐标输入框-->
       <map-point :disabled="disabled" v-if="input === 'map-point'" :placeholder="'请选择' + label" :header="label"
        :initial-point="myValue" @point-selected="handlePointSelected" v-model="myValue" :readonly="readonly"
        style="width: 100%" :content="content"></map-point>
      <!--地图折线输入框-->
      <map-line :disabled="disabled" v-if="input === 'map-line'" :placeholder="placeholder || '请选择' + label"
        :header="label" :initial-line="myValue" @line-selected="handleLineSelected" v-model="myValue"
        :readonly="readonly" style="width: 100%"></map-line>
      <!--地图多边形输入框-->
      <map-polygon :disabled="disabled" v-if="input === 'map-polygon'" :placeholder="placeholder || '请选择' + label"
        :header="label" :initial-polygon="myValue" @line-selected="handlePolygonSelected" v-model="myValue"
        :readonly="readonly" style="width: 100%"></map-polygon>
      <!--拍摄-->
      <camera :disabled="disabled" v-if="input === 'camera'" :placeholder="placeholder || '请拍摄' + label" :header="label"
        v-model="myValue" :readonly="readonly" :attribute="attribute" :accept="accept" style="width: 100%"></camera>
      <!--启用禁用输入框-->
      <el-select :disabled="disabled" v-if="input === 'enable'" :placeholder="placeholder || '请选择' + label"
        v-model="myValue" filterable @change="handleChange">
        <el-option value=""></el-option>
        <el-option :value=1 label="启用"></el-option>
        <el-option :value=0 label="禁用"></el-option>
      </el-select>
    </el-form-item>
  </el-col>
</template>
<script>
export default {
  props: {
    attribute: {},
    span: { default: 6 },
    type: {},
    readonly: {type: Boolean, default: false },
    disabled: { default: false },
    label: {},
    input: {},
    value: {},
    required: {},
    types: [],
    upload: { default: false },
    editor: { default: false },
    date: { default: false },
    datetime: { default: false },
    filetype: {},
    rows: {},
    autosize: { type: [Boolean, Object], default: false },
    accept: {},
    multiple: { default: false },
    node: { default: false },
    enable: { default: false },
    myid: {},
    placeholder: {
      type: String,
      default: ""
    },
    content:String
  },
  data() {
    return {
      myValue: this.value,
    };
  },
  methods: {
    handlePointSelected(point) {
      if (point.lng == undefined && point.lat == undefined) this.myValue = null
      else this.myValue = point.lng + "," + point.lat; // 更新表单项的值为选择的经纬度
      // 处理地图选择器选择的点的经纬度
      // console.log('选择的经纬度：', point);
      // 这里可以根据需求关闭地图选择器界面
    },
    handleLineSelected(line) {
      this.myValue = line;
      // console.log('line: ', this.myValue)
    },
    handlePolygonSelected(polygon) {
      this.myValue = polygon;
      // console.log('polygon: ', this.myValue)
    },
    handleChange() {
      this.$emit('change', this.myValue)
    },
    formatDate(dateString) {
      if(dateString=="0001-01-01T00:00:00") return null;
      if(dateString==null)return null;
      const date = new Date(dateString); // 解析日期字符串
      // 获取日期的各个部分
      const year = String(date.getFullYear()).padStart(4, '0'); // 先转字符串再补零
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }
  },
  mounted() {
  },
  beforeMount() {
    if (this.input === "node") {
      this.$multiple(this.multiple);
    }
    if (this.input === "datetime") {
      this.myValue = this.formatDate(this.value);
    }
  },

  watch: {
    //监听内容变化
    value(newValue) {
      if (this.input === "datetime") {
        this.myValue = this.formatDate(newValue);
      }
      else this.myValue = newValue
    },
    myValue(newValue) {
      this.$emit('input', newValue)
    }
  },

}
</script>

<style></style>